import { SITE_NAME, toAbsoluteUrl } from './seo-constants'

interface BreadcrumbItem {
  name: string
  pathOrUrl: string
}

export function buildBreadcrumbList(items: BreadcrumbItem[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: toAbsoluteUrl(item.pathOrUrl),
    })),
  }
}

export function buildOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: toAbsoluteUrl('/'),
    sameAs: ['https://pdbuddy.app/', 'https://nosilverbullet4pd.com/'],
  }
}

export function buildWebsiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: toAbsoluteUrl('/'),
    potentialAction: {
      '@type': 'SearchAction',
      target: `${toAbsoluteUrl('/news')}?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  }
}
